var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "28.000000pt",
    height: "28.000000pt",
    viewBox: "0 0 28.000000 28.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,28.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 252 l-26 -28 28 -27 c31 -30 53 -25 25 5 -14 16 -14 18 0 18 26 0 71 -20 95 -42 48 -46 17 -136 -52 -154 -63 -15 -146 34 -146 87 0 10 -4 19 -10 19 -19 0 -10 -49 15 -79 64 -75 189 -61 230 25 13 28 14 41 5 69 -16 47 -63 85 -106 85 -35 0 -42 8 -23 27 6 6 7 13 1 17 -5 3 -21 -7 -36 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.d8b0727804ff96c4b48d67c6da1adf4d.svg";
export { ForwardRef as ReactComponent };